/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { KeyspacesTableRestoreDestination } from '../models/KeyspacesTableRestoreDestination';

export class RestoreKeyspacesTableRequest {
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;
  'destination': KeyspacesTableRestoreDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "KeyspacesTableRestoreDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreKeyspacesTableRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

